import type { GetCards200ResponseCardsItem } from './getCards200ResponseCardsItem';

export interface GetCards200Response {
  cards?: GetCards200ResponseCardsItem[];
  message?: string;
  success: boolean;
}
